import { render, staticRenderFns } from "./year_turnover_acco.vue?vue&type=template&id=4d69f9e6&scoped=true"
import script from "./year_turnover_acco.vue?vue&type=script&lang=js"
export * from "./year_turnover_acco.vue?vue&type=script&lang=js"
import style0 from "./year_turnover_acco.vue?vue&type=style&index=0&id=4d69f9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69f9e6",
  null
  
)

export default component.exports